import { useAuth } from "auth";
import React, { FC, ReactNode } from "react";

interface Props {
  readonly children: ReactNode;
}

export const Authentication: FC<Props> = ({ children }) => {
  const { auth } = useAuth();

  return <>{auth?.authenticated && children}</>;
};
